module.exports = __webpack_public_path__ + "components/rating/static/star-empty-ebf008e320b8d3d7a5b0ec2e179ce84f.svg";